import { throwError } from "@saleshub/utils";
import { createRoot } from "react-dom/client";

import App from "./App";

createRoot(document.getElementById("root") ?? throwError("Could not find `root` DOM element.")).render(<App />);
